import React, { useEffect, useState,  } from 'react'
import { useNavigate } from 'react-router-dom';

import { useHideMenu } from '../hooks/useHideMenu';
import { RegistroUsuario } from '../components/registroUsuario';
import { getUsuarioStorage } from '../helpers/getUsuarioStorage';
import { useGetPantallas } from '../hooks/useGetPantallas';


export const Ingreso = () => {
	
    let [usuario] = useState( getUsuarioStorage() );
    
    const pantallas= usuario.pantallas ? usuario.pantallas.split(",") : [];
    console.log(pantallas)

	const navigate = useNavigate();
    useEffect(() => {
        if(usuario.uidUsuario !== null){
            
            navigate("/inicio")
            // if(pantallas["escritorios"]) return navigate("/modulo")
            
            // creacionescritorios,informes,listapacientes,tiposatencion,usuarios,videoslistas
            
        }
    }, [usuario.uidUsuario, navigate ])
	

		useHideMenu( true )
		
	return (
	 
		< RegistroUsuario />
		
	)
}
